/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';
import 'bootstrap-select';
import './slider.js'
import './video.js'
import AOS from 'aos';
import LazyLoad from "vanilla-lazyload";
import 'ics';
import './disclaimer';
import filesize from "./util/filesize";
import Player from '@vimeo/player';
import {calculateEducationFees} from "./calculators/education";
import {calculateGoal} from "./calculators/goal";
import {calculateRetirement} from "./calculators/retirement";

$(document).ready(() => {
  AOS.init({
    once: true,
    duration: 900,
    disableMutationObserver: false,
  });

  AOS.refresh(true);

  const lazyLoadInstance = new LazyLoad({
    threshold: 100,
  });

  // Get CSS variables
  let root = getComputedStyle(document.documentElement);
  let colorPrimary = root.getPropertyValue('--primary');
  let colorSecondary = root.getPropertyValue('--secondary');
  let xsBreakpoint = root.getPropertyValue('--breakpoint-xs').replace('px', '');
  let smBreakpoint = root.getPropertyValue('--breakpoint-sm').replace('px', '');
  let mdBreakpoint = root.getPropertyValue('--breakpoint-md').replace('px', '');
  let lgBreakpoint = root.getPropertyValue('--breakpoint-lg').replace('px', '');
  let xlBreakpoint = root.getPropertyValue('--breakpoint-xl').replace('px', '');

  // Add scroll class on scroll/load
  const $window = $(window);
  const $body = $('body');
  $window.on("scroll load", function () {
    if ($window.scrollTop() > 50) {
      $body.addClass("scroll-down");
    } else {
      //remove the background property so it comes transparent again (defined in your css)
      $body.removeClass("scroll-down");
    }
  });

  // Add scroll class to header on navbar toggle
  $('.navbar-toggler').on('click', function () {
    if (!$body.hasClass('scroll-down')) {
      $body.toggleClass('scroll-down');
    }
    ;
  });

  // Move modals before body fix for z-index inherit bug
  $('.modal ').insertAfter($('body'));

  // Popup modal
  $('a[href*="#bs-modal"]').each(function() {
    $(this).attr('data-toggle', 'modal');
  });

  // Popup modal
  if($('#popup').length) {
    // Only show modal if url's hash isn't #accept
    if ( window.location.hash !== '#accept' ) {
      $('#popup').modal('show');
    } else {
      // Prevent url sharing from hiding the modal
      window.location.hash = '';
    }

    $('.popup-close').on('click', function() {
      $('#popup').modal('hide');
    });

    // Handle multi-button popup
    $('.js-popup-destination').on('click', function(e) {
      if ( $(this).attr('href') === '#' ) {
        e.preventDefault();
        $('#popup').modal('hide');
      }
    });

  }




  // players
  let vimeoPlayer;

  // Video player
  if ($('div[data-id="vimeo-video"]').length) {
    const $vimeoVideo = $('iframe[data-id="vimeo-video"]');
    const $vimeoPlayButton = $('div[data-id="vimeo-video"]');

    if ($vimeoVideo.length && $vimeoPlayButton.length) {
      vimeoPlayer = new Player($vimeoVideo);

      $vimeoPlayButton.on('click', function () {
        vimeoPlayer.play();
        $vimeoPlayButton.hide();
      });

      vimeoPlayer.on('pause', function () {
        $vimeoPlayButton.show();
      });
    }
  }

  // Scroll to open accordion
  // see example https://stackoverflow.com/questions/35992900/bootstrap-accordion-scroll-to-top-of-active-open-accordion-on-click#answer-35992958
  $('.accordion__collapse').on('shown.bs.collapse', function (e) {
    const header = $('.header').height();
    var $panel = $(this).closest('.accordion__item');
    $('html,body').animate({
      scrollTop: $panel.offset().top - header
    }, 500);
  });

  // Download calendar ICS file
  $('.add-to-calendar a').on('click', function (e) {
    e.preventDefault();

    const ics = require('ics')

    // Get text from calendar listing
    let title = $(this).closest('tr').find('.event-title').text();
    let date = $(this).closest('tr').find('.event-date').text();

    // Get date format and split to array
    let date_array = date.split('/');
    let date_day = date_array[0];
    let date_month = date_array[1];
    let date_year = date_array[2];

    // Grab calendar data
    const event = {
      start: [date_year, date_month, date_day, 0, 0], end: [date_year, date_month, date_day, 0, 0], //duration: { hours: 0, minutes: 0 },
      title: title, status: 'CONFIRMED',
    }

    // Build file with ICS calendar data
    ics.createEvent(event, (error, value) => {
      if (error) {
        alert('ICS file could not be downloaded.');
        // console.log(error)
        return
      }

      //console.log(value);

      // Download ICS file with calendar data
      window.open('data:text/calendar;charset=utf8,' + escape(value));
    });
  });

  // Enable bootstrap select for all selects
  $('select').selectpicker();

  $('.faux-filters a').each(function () {
    var $this = $(this);

    // Insights filters
    if ($this.data('slug') && window.location.search.match(new RegExp(`^\\?tag=${$this.data('slug')}$`))) {
      $this.addClass('active');
    }
  });

  if (!$('.faux-filters a.nav-link.active').length) {
    $('.faux-filters a.nav-link:first').addClass('active');
  }

  // Update file size to correct value from S3
  $('.latest-results').find('[data-filesize-url]').each(function () {
    filesize.filesize($(this));
  });

  $('.files').find('[data-filesize-url]').each(function () {
    filesize.filesize($(this));
  });

  $('.list-files').find('[data-filesize-url]').each(function () {
    filesize.filesize($(this));
  });

  // JS for sub nav items
  $(".nav-link").on("click", () => {
    $(".nav-item").each(function () {
      $(this).children().removeClass('active')
    })
  })
});

$(() => {
  /**
   * initMap
   *
   * Renders a Google Map onto the selected jQuery element
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   jQuery $el The jQuery element.
   * @return  object The map instance.
   */
  function initMap($el) {
    var styles = [{
      "elementType": "geometry", "stylers": [{
        "color": "#f5f5f5"
      }]
    }, {
      "elementType": "labels.icon", "stylers": [{
        "visibility": "off"
      }]
    }, {
      "elementType": "labels.text.fill", "stylers": [{
        "color": "#616161"
      }]
    }, {
      "elementType": "labels.text.stroke", "stylers": [{
        "color": "#f5f5f5"
      }]
    }, {
      "featureType": "administrative.land_parcel", "elementType": "labels.text.fill", "stylers": [{
        "color": "#bdbdbd"
      }]
    }, {
      "featureType": "poi", "elementType": "geometry", "stylers": [{
        "color": "#eeeeee"
      }]
    }, {
      "featureType": "poi", "elementType": "labels.text.fill", "stylers": [{
        "color": "#757575"
      }]
    }, {
      "featureType": "poi.park", "elementType": "geometry", "stylers": [{
        "color": "#e5e5e5"
      }]
    }, {
      "featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{
        "color": "#9e9e9e"
      }]
    }, {
      "featureType": "road", "elementType": "geometry", "stylers": [{
        "color": "#ffffff"
      }]
    }, {
      "featureType": "road.arterial", "elementType": "labels.text.fill", "stylers": [{
        "color": "#757575"
      }]
    }, {
      "featureType": "road.highway", "elementType": "geometry", "stylers": [{
        "color": "#dadada"
      }]
    }, {
      "featureType": "road.highway", "elementType": "labels.text.fill", "stylers": [{
        "color": "#616161"
      }]
    }, {
      "featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{
        "color": "#9e9e9e"
      }]
    }, {
      "featureType": "transit.line", "elementType": "geometry", "stylers": [{
        "color": "#e5e5e5"
      }]
    }, {
      "featureType": "transit.station", "elementType": "geometry", "stylers": [{
        "color": "#eeeeee"
      }]
    }, {
      "featureType": "water", "elementType": "geometry", "stylers": [{
        "color": "#e5e4e3"
      }, {
        "saturation": -100
      }]
    }, {
      "featureType": "water", "elementType": "labels.text.fill", "stylers": [{
        "color": "#9e9e9e"
      }]
    }];

    // Find marker elements within map.
    var $markers = $el.find('.marker');

    // Create gerenic map.
    var mapArgs = {
      zoom: $el.data('zoom') || 16, mapTypeId: google.maps.MapTypeId.ROADMAP, styles: styles,
    };
    var map = new google.maps.Map($el[0], mapArgs);

    // Add markers.
    map.markers = [];
    $markers.each(function () {
      initMarker($(this), map);
    });

    // Center map based on markers.
    centerMap(map);

    // Return map instance.
    return map;
  }

  /**
   * initMarker
   *
   * Creates a marker for the given jQuery element and map.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   jQuery $el The jQuery element.
   * @param   object The map instance.
   * @return  object The marker instance.
   */
  function initMarker($marker, map) {

    // Get position from marker.
    var lat = $marker.data('lat');
    var lng = $marker.data('lng');
    var latLng = {
      lat: parseFloat(lat), lng: parseFloat(lng),
    };

    var markerIcon = $marker.data('icon');

    // Create marker instance.
    var marker = new google.maps.Marker({
      position: latLng, map: map, icon: markerIcon,
    });

    // Append to reference for later use.
    map.markers.push(marker);

    // If marker contains HTML, add it to an infoWindow.
    if ($marker.html()) {
      // Create info window.
      var infowindow = new google.maps.InfoWindow({
        content: $marker.html(),
      });

      // Show info window when marker is clicked.
      google.maps.event.addListener(marker, 'click', function () {
        infowindow.open(map, marker);
      });
    }
  }

  /**
   * centerMap
   *
   * Centers the map showing all markers in view.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   object The map instance.
   * @return  void
   */
  function centerMap(map) {
    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();

    map.markers.forEach(function (marker) {
      bounds.extend({
        lat: marker.position.lat(), lng: marker.position.lng(),
      });
    });

    // Case: Single marker.
    if (map.markers.length == 1) {
      map.setCenter(bounds.getCenter());
      // Case: Multiple markers.
    } else {
      map.fitBounds(bounds);
    }
  }

  // Render maps on page load.
  $(document).ready(function () {
    $('.acf-map').each(function () {
      var map = initMap($(this));
    });
  });
})

/**
 * Meet the team dropdowns
 */
$(() => {
  const SNAP_LG = 992;
  const SNAP_SM = 767;

  /**
   * Fixes the flex order so the people dropdown appears in the right place.
   */
  const fixFlexOrder = () => {
    let j = 0;
    $('.js-flex-reorder>.js-flex-panel').each((i, el) => {
      const $panel = $(el);
      const $dropdown = $(el).next();
      const windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      const divisor = windowWidth > SNAP_LG ? 3 : windowWidth < SNAP_SM ? 1 : 2;
      const rowOrder = Math.ceil((j + 1) / divisor);
      if ($panel.is(':visible')) {
        // Fix flex
        $panel.css('order', rowOrder).addClass('is-number-' + (j + 1));
        $dropdown.css('order', rowOrder + 1);
        j++;
      } else {
        // Reset everything else to zero
        $panel.css('order', 0);
        $dropdown.css('order', 0);
      }
    });
  };

  $('.people__nav li:first-child a[data-filter]').addClass('active');
  const teamFilterFirst = $('.people__nav li:first-child a[data-filter]').attr('data-filter');
  $('[data-teams]').hide();
  $(`[data-teams*="${teamFilterFirst}"]`).show();

  fixFlexOrder();

  $('a[data-filter]').on('click', function () {
    // Close any stray open person dropdowns
    $('section.people .collapse').collapse('hide');

    // Hide everything
    $('[data-teams]').hide();

    // Remove active class to link if it has one
    $('a[data-filter]').removeClass('active');

    // Add active class to link
    $(this).addClass('active');

    // Show according to filters
    const teamFilter = $(this).attr('data-filter');
    $(`[data-teams*="${teamFilter}"]`).show();

    // Re-apply flex order fix
    fixFlexOrder();
  });

  const videoContentOverlayObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        const $overlayElement = $(entry.target);

        if ($overlayElement.hasClass('-active') && !entry.isIntersecting) {
          const videoElement = $overlayElement.find('video')[0];
          if (videoElement) {
            videoElement.pause();
          } else {
            const iframeElement = $overlayElement.find('.js-video-iframe')[0];
            iframeElement.contentWindow.postMessage('{"method":"pause","value":""}', '*');
          }

          $overlayElement.find('.video-playbtn').hide();
          $overlayElement.find('.video-replaybtn').show();
          $overlayElement.find('.video-poster').fadeInVisibility(400);
          $overlayElement.find('.video-content-overlay__item').fadeInVisibility(400);
          $overlayElement.find('.video-content-overlay__close').hide();
        }
      }
    });
  });

  $(document).on('click', '.video-content-overlay__close', function (event) {
    const $self = $(this);
    const $parent = $self.closest('.video-content-overlay');
    const videoElement = $parent.find('video')[0];
    const iframeElement = $parent.find('.js-video-iframe')[0];

    if (videoElement) {
      videoElement.pause();
    } else if (iframeElement) {
      iframeElement.contentWindow.postMessage('{"method":"pause","value":""}', '*');
    }

    $parent.find('.video-playbtn').hide();
    $parent.find('.video-replaybtn').show();
    $parent.find('.video-poster').fadeInVisibility(400);
    $parent.find('.video-content-overlay__item').fadeInVisibility(400);

    $self.hide();
  });

  $(document).on('click', '.video-content-overlay .js-video-play', function (event) {
    event.preventDefault();

    const $self = $(this);
    const $parent = $self.closest('.video-content-overlay');
    const videoElement = $parent.find('video')[0];
    const iframeElement = $parent.find('.js-video-iframe')[0];

    $parent.addClass('-active');

    if (videoElement) {
      $(videoElement).show();
      videoElement.play();
    } else if (iframeElement) {
      iframeElement.contentWindow.postMessage('{"method":"play","value":""}', '*');
    }

    // Hide elements
    $parent.find('.video-poster').fadeOutVisibility(400);
    $parent.find('.video-content-overlay__item').fadeOutVisibility(400);
    $parent.find('.video-content-overlay__close').show();
  });

  // Start observing the video-content-overlay element
  const $overlayElements = $('.video-content-overlay');
  $overlayElements.each((index, overlayElement) => {
    videoContentOverlayObserver.observe(overlayElement);
  });

  // Video and iframe auto transform scale
  const adjustMediaSize = () => {
    const $media = $('.video-content-overlay .video-iframe, .video-content-overlay video');
    const $container = $('.video-content-overlay .video-wrapper');

    const containerWidth = $container.width();
    const containerHeight = $container.height();
    const aspectRatio = 16 / 9; // Adjust aspect ratio as needed

    let mediaWidth = containerHeight * aspectRatio;
    let mediaHeight = containerHeight;

    if (mediaWidth < containerWidth) {
      mediaWidth = containerWidth;
      mediaHeight = containerWidth / aspectRatio;
    }

    $media.css({
      width: `${mediaWidth}px`,
      height: `${mediaHeight}px`,
    });
  };

  // Adjust the size of both video and iframe on window resize
  $(window).on('resize', adjustMediaSize);
  adjustMediaSize();
});

// let gender = "";
// $("input:radio[name='gender']").on("change", function(){
//   gender = $("input:radio[name='gender']:checked").val();
// })

// console.log({ gender })
let currency = "£"
$(".currency-select-item").on("click", function () {
  const selectedCurrency = $(this).attr("id")
  if (selectedCurrency === "STERLING") {
    currency = "£"
  } else {
    currency = "$"
  }
})

let eduCurrency = "£"
$(".currency-select-edu-item").on("click", function () {
  const selectedCurrency = $(this).attr("id")
  if (selectedCurrency === "STERLING") {
    eduCurrency = "£"
  } else {
    eduCurrency = "$"
  }
})

let savCurrency = "£"
$(".currency-select-sav-item").on("click", function () {
  const selectedCurrency = $(this).attr("id")
  if (selectedCurrency === "STERLING") {
    savCurrency = "£"
  } else {
    savCurrency = "$"
  }
})


// Education fees Calculator
$("#calculate-education").on("click", function () {
  const annualCost = $("input[name='education-fees']").val();
  const assosiatedCost = $("input[name='associated-cost']").val();
  const amountSaved = $("input[name='amount-saved']").val();
  const yaerasInFurtherEducation = $("input[name='years-in-further-education']").val();
  const date = $("select[name='further-education-commence custom-select']").val();
  const rate = $("input[name='education-growth-rate']:checked").val();

  // calculate the data
  const data = calculateEducationFees(annualCost, assosiatedCost, amountSaved, rate, date, yaerasInFurtherEducation, eduCurrency);

  // show results and hide form
  $("#education-form").toggle()
  $("#educartion-res").toggle()

  // set values in view
  $("#totalCost").text(data["Total Costs per year"]);
  $("#moneySavGrow").text(data["Money Saved + Growth"]);
  $("#yRemaining").text(data["Years Remaining"]);
  $("#AGR").text(data["Annual Growth Rate"]);
  $("#YEB").text(data["Year Education Begins"])
  $("#DOE").text(data["Duration of Education"]);
  $("#TCOE").text(data["Total cost of further education"]);
  $("#MSAR").text(data["Monthly savings amount required"])
  $(".modal-content").scrollTop(0);
})

// Education fees Reset btn
$("#recalculate-education").on("click", function () {
  $("input[name='education-fees']").val();
  $("input[name='associated-cost']").val();
  $("input[name='amount-saved']").val();
  $("input[name='years-in-further-education']").val();
  $("select[name='further-education-commence custom-select']").val();


  $(".modal-content").scrollTop(0);
  $("#education-form").toggle()
  $("#educartion-res").toggle()
})

// Goal Calculator
$("#calculate-goal").on("click", function () {
  const goal = $("input[name='savings-goal']").val();
  const yearRequired = $("select[name='year-required custom-select']").val();
  const amountSaved = $("input[name='amount-saved-towards']").val();
  const rate = $("input[name='savings-growth-rate']:checked").val();

  // calculate the data
  const data = calculateGoal(goal, yearRequired, amountSaved, rate, savCurrency);

  // show results and hide form
  $("#goal-form").toggle()
  $("#goal-res").toggle()

  // set values in view
  $("#target").text(data["Target"]);
  $("#MSG").text(data["Money_Saved_Growth"]);
  $("#YR").text(data["Years Remaining"]);
  $("#GAGR").text(data["Annual Growth Rate"]);
  $("#YMSAR").text(savCurrency + data["Your monthly saving amount required is"]);
})

// Goal Reset btn
$("#recalculate-goal").on("click", function () {
  // console.log("hello")
  $("input[name='savings-goal']").val();
  $("select[name='year-required custom-select']").val();
  $("input[name='amount-saved-towards']").val();
  $(".modal-content").scrollTop(0);
  $("#goal-form").toggle()
  $("#goal-res").toggle()
})

// Retirement Calculator
$("#calculate-pension").on("click", function () {
  const age = $("input[name='age']").val();
  const retire = $("input[name='retire']").val();
  const firstYear = $("input[name='first-year']").val();
  const setAside = $("input[name='set-aside']").val();
  const expectToAdd = $("input[name='expect-to-add-this']").val()
  const pensionPot = $("input[name='pension-pot']").val()
  const expectToAddEach = $("input[name='expect-to-add-each']").val()
  const gender = $("input:radio[name='gender']:checked").val();
  const rate = $("input[name='retirement-growth-rate']:checked").val();
  let isMale
  const target = Number(retire) - Number(age)
  const fYear = new Date().getFullYear() + target

  if (gender === "male") {
    isMale = true
  } else {
    isMale = false
  }

  // calculate the data
  const data = calculateRetirement(isMale, age, retire, firstYear, setAside, expectToAdd, pensionPot, expectToAddEach, rate, true)

  // show results and hide form
  $("#retirement-form").toggle()
  $("#retirement-res").toggle()

  // set values in view
  setRetirementView(firstYear, data, fYear)
})

// calc value
$("input[name='calc']").on("change", function () {
  const age = $("input[name='age']").val();
  const retire = $("input[name='retire']").val();
  const firstYear = $("input[name='first-year']").val();
  const setAside = $("input[name='set-aside']").val();
  const expectToAdd = $("input[name='expect-to-add-this']").val()
  const pensionPot = $("input[name='pension-pot']").val()
  const expectToAddEach = $("input[name='expect-to-add-each']").val()
  const gender = $("input:radio[name='gender']:checked").val();
  const rate = $("input[name='retirement-growth-rate']:checked").val();
  let isMale
  const target = Number(retire) - Number(age)
  const fYear = new Date().getFullYear() + target

  if (gender === "male") {
    isMale = true
  } else {
    isMale = false
  }

  if ($(this).val() !== "today") {
    const data = calculateRetirement(isMale, age, retire, firstYear, setAside, expectToAdd, pensionPot, expectToAddEach, rate, true)
    setRetirementView(firstYear, data, fYear, true)
    return
  }

  const data = calculateRetirement(isMale, age, retire, firstYear, setAside, expectToAdd, pensionPot, expectToAddEach, rate, false)
  setRetirementView(firstYear, data, fYear, true)
  // console.log("this: ", $(this).val());
})

// Custom fadeOut function
$.fn.fadeOutVisibility = function(duration, callback) {
  return this.each(function() {
    var $elem = $(this);
    $elem.animate({ opacity: 0 }, duration, function() {
        $elem.css('visibility', 'hidden').removeClass('visible').addClass('hidden');
        if (callback) callback();
    });
});
};

// Custom fadeIn function
$.fn.fadeInVisibility = function(duration, callback) {
  return this.each(function() {
    var $elem = $(this);
    $elem.css('visibility', 'visible').removeClass('hidden').addClass('visible').animate({ opacity: 1 }, duration, function() {
        if (callback) callback();
    });
  });
};

function setRetirementView(firstYear, data, fYear, isChart) {
  $("#PANIFY").text(currency + firstYear)
  $("#CurrAge").text(data["Current age"])
  $("#retAge").text(data["Retirement age"])
  $("#MAS").text(currency + data["Money already saved"])
  $("#CPP").text(currency + data["Current pension pot"])
  $("#SPG").text(currency + data["Savings + Pension + Growth"])
  $("#ESPY").text(currency + data["Expected savings per year"])
  $("#EPSPY").text(currency + data["Expected pension savings per year"])
  $("#PAGR").text(data["Assumed growth rate"] + "%")
  $("#ARYWN").text(currency + data["At retirement you will need"])
  $("#ARYWHS").text(currency + data["At retirement you will have saved"])
  $("#fMoneyYear").text(fYear + " Money")
  if (!isChart) {
    $(".modal-content").scrollTop(0);
  }
}

// Reset btn
$("#recalculate-pension").on("click", function () {
  $(".modal-content").scrollTop(0);
  $("#retirement-form").toggle()
  $("#retirement-res").toggle()
  $("#disclaimer-text").toggle()
})

/**
 * Open dropdowns on hover instead of click only for desktop
 */
$(() => {
  let root = getComputedStyle(document.documentElement);
  let $dropdown = $("#navbar .dropdown, #menu-right-header-menu .dropdown");
  let $dropdownToggle = $("#navbar .dropdown-toggle , #menu-right-header-menu .dropdown-toggle");
  let $dropdownMenu = $("#navbar .dropdown-menu, #menu-right-header-menu .dropdown-menu");
  let lgBreakpoint = root.getPropertyValue('--breakpoint-lg');
  let showClass = "show";

  // console.log(lgBreakpoint);

  $(window).on("load resize", function () {
    if (this.matchMedia("(min-width: " + lgBreakpoint + ")").matches) {
      $dropdown.hover(
        function () {
          const $this = $(this);
          $this.addClass(showClass);
          $this.find($dropdownToggle).attr("aria-expanded", "true");
          $this.find($dropdownMenu).addClass(showClass);
        },
        function () {
          const $this = $(this);
          $this.removeClass(showClass);
          $this.find($dropdownToggle).attr("aria-expanded", "false");
          $this.find($dropdownMenu).removeClass(showClass);
        }
      );
    }
  });
});
